import { AbstractControl, ValidatorFn, ValidationErrors, Validators } from '@angular/forms';
import { Observable, of, Subscription, connectable, Subject } from 'rxjs';
import { switchMap, map, distinctUntilChanged, tap } from 'rxjs/operators';
import { ICpEntity } from '../cp-configuration/view-model';

export interface SeConstraintValidatorReturnType {
    subscription: Subscription;
    validator: ValidatorFn;
}

/**
 * Controlla la validità della proprietà di una entity.
 * TODO: Scollega la validazione di Angular e quella del modello, crea più problemi di quanti ne risolva.
 */
export function SeConstraintValidator(
    entity$: Observable<ICpEntity | undefined>,
    property: string,
    required: boolean
): SeConstraintValidatorReturnType {
    let latestConstraintError: ValidationErrors | null = null;
    let latestRequiredError: ValidationErrors | null = null;
    let latestEntity: ICpEntity | undefined;

    /**
     * Raccogli tutti i check e mappali al propertyErrorStatus della entity.
     * Se c'è almeno un errore, la validazione fallisce.
     * !!! Non c'è bisogno di unsubscribe perché lo stream finisce quando il controllo è cancellato, ma
     * !!! questo vale solo per le CP.
     */
    const entityErrors$ = entity$.pipe(
        distinctUntilChanged(),
        tap((e) => {
            latestEntity = e;
        }),
        switchMap((e) => {
            if (!e || !e.propertyErrorStatus) {
                return of(false);
            }

            return e.propertyErrorStatus(property, 'seConstraint');
        }),
        map((isInError) => {
            if (isInError) {
                latestConstraintError = {
                    seConstraint: true,
                };
            } else {
                latestConstraintError = null;
            }
        })
    );

    const obs = connectable(entityErrors$, {
        connector: () => new Subject(),
        resetOnDisconnect: false,
    });

    const validator = (control: AbstractControl) => {
        if (required) {
            latestRequiredError = Validators.required(control);
            const isValid = latestRequiredError === null;

            if (latestEntity && latestEntity.getPropertyErrorStatus && latestEntity.setPropertyErrorStatus) {
                latestEntity.setPropertyErrorStatus(property, 'required', isValid);
            }
        }

        return latestConstraintError || latestRequiredError;
    };

    return {
        subscription: obs.connect(),
        validator,
    };
}
